var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyShoppingcart = function SvgImgEmptyShoppingcart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.023,
    cy: 67.594,
    rx: 13.977,
    ry: 2.937,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.483,
    cy: 67.227,
    rx: 26.483,
    ry: 4.773,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.742 16.2c0-.371.3-.672.672-.672h44.138c.37 0 .67.3.67.671v46.984c0 1.184-.958 2.143-2.142 2.143H13.885a2.143 2.143 0 0 1-2.143-2.143V16.2z",
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.55 18.402c0-.591.479-1.071 1.07-1.071h39.725c.591 0 1.071.48 1.071 1.071v42.579a2.543 2.543 0 0 1-2.542 2.542H16.092a2.542 2.542 0 0 1-2.543-2.542V18.402z",
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.066 64.957h-7.075c-13.312-.878-33.564-7.188-36.313-35.544v34.073c0 .812.659 1.471 1.471 1.471h34.842a53.31 53.31 0 0 0 7.075 0z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.015 9.5-5.262 5.777h43.46L50.95 9.5a2.143 2.143 0 0 0-1.584-.7H19.6c-.603 0-1.178.254-1.584.7z",
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.777 11.118 16.26 13.89h36.446l-2.517-2.772a2.542 2.542 0 0 0-1.883-.833H20.66c-.717 0-1.4.302-1.882.833z",
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.46 22.805c0 7.3-6.258 13.217-13.977 13.217-7.72 0-13.977-5.918-13.977-13.217",
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M18.299 22.805h4.414v.8h-4.414zM46.253 22.805h4.414v.8h-4.414z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.009 52.269a.671.671 0 0 1 .665-.762h19.434c.407 0 .72.358.665.762l-1.226 9a2.142 2.142 0 0 1-2.123 1.854H51.358a2.143 2.143 0 0 1-2.123-1.853l-1.226-9.002z",
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 1.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.786 66.126c0 .773-.628 1.403-1.407 1.403-.778 0-1.407-.63-1.407-1.403s.629-1.403 1.407-1.403c.779 0 1.407.63 1.407 1.403zM53.545 66.126c0 .773-.629 1.403-1.407 1.403-.779 0-1.407-.63-1.407-1.403s.628-1.403 1.407-1.403c.778 0 1.407.63 1.407 1.403z",
    fill: "#BDBDBD",
    stroke: "#BDBDBD",
    strokeWidth: 1.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m49.195 61.72-2.207-15.052h-5.15",
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m62.594 51.56-1.009 11.51M54.229 51.56l1.009 11.51M68.322 55.48H48.46",
    stroke: "#BDBDBD",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyShoppingcart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img_empty_shoppingcart.68c76a1e546c3d253781eb6c7814c1c9.svg";